exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".centerPage {\r\n  position: absolute;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n}\r\n.centerPage h4 {\r\n  text-align: center;\r\n  color: #0064b7;\r\n}\r\n", ""]);
